import { BlockProps } from "../BlocksManager/registry";
import Link from "next/link";
import {
  ArrowRightCircle,
  Building2,
  ChevronDown,
  Mail,
  MapPin,
  MessageSquare,
  Pencil,
  Phone,
  User,
} from "lucide-react";

export default function Formulaire({ data }: BlockProps) {
  if (!data) return null;

  const variantKey = String(data.page || "").trim().toUpperCase();

  const optionsMap: Record<string, string[]> = {
    CHEFS_ENTREPRISE_RH_CSE: ["Chef d'entreprise", "RH", "CSE"],
    SALARIES: ["Salarié"],
    RESEAU_ETABLISSEMENTS: ["Réseau d’établissements"],
    CONCEPT: ["Chef d'entreprise", "RH", "CSE", "Salarié", "Réseau d’établissements"],
  };

  const options = optionsMap[variantKey] || [];

  console.log("data.variante =", data.page);
  console.log("variantKey =", variantKey);
  console.log("options =", options);

  return (
    <section id="formulaire" className="relative overflow-hidden bg-violet-semi-light px-6 py-16 md:px-10 lg:px-16 lg:py-20">
      <div className="absolute -left-12 top-32 h-36 w-36 rounded-full bg-violet md:h-48 md:w-48" />
      <div className="absolute -left-3 top-1/2 h-12 w-12 rounded-full bg-violet md:h-16 md:w-16" />
      <div className="absolute right-48 top-0 h-24 w-24 rounded-full bg-violet md:h-32 md:w-32" />
      <div className="absolute -bottom-8 right-10 h-20 w-20 rounded-full bg-violet md:h-56 md:w-56" />

      <div className="relative z-10 mx-auto max-w-4xl">
        <h2 className="text-center font-literata text-[42px] font-bold leading-tight text-black lg:text-[56px]">
          {data.titre}
        </h2>

        <form className="mx-auto mt-10 max-w-3xl">
          <div className="grid grid-cols-2 gap-4 md:gap-5">
            <div className="relative col-span-2 md:col-span-1">
              <Building2 className="pointer-events-none absolute left-5 top-1/2 h-5 w-5 -translate-y-1/2 text-violet" />

              <select
                defaultValue=""
                className="h-16 w-full appearance-none rounded-full border-2 border-violet bg-white pl-14 pr-12 text-[14px] text-text-body shadow-[0_8px_18px_rgba(124,106,242,0.22)] outline-none"
                required
              >
                <option value="" disabled>
                  Je suis un(e)*
                </option>

                {options.map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </select>

              <ChevronDown className="pointer-events-none absolute right-5 top-1/2 h-5 w-5 -translate-y-1/2 text-black" />
            </div>

            <div className="relative col-span-2 md:col-span-1">
              <Building2 className="pointer-events-none absolute left-5 top-1/2 h-5 w-5 -translate-y-1/2 text-violet" />
              <input
                type="text"
                placeholder="Nom de l’entreprise"
                className="h-16 w-full rounded-full bg-white pl-14 pr-5 text-[14px] text-black outline-none placeholder:text-gray-500"
                required
              />
            </div>

            <div className="relative col-span-1">
              <User className="pointer-events-none absolute left-5 top-1/2 h-5 w-5 -translate-y-1/2 text-violet" />
              <input
                type="text"
                placeholder="Nom"
                className="h-16 w-full rounded-full bg-white pl-14 pr-5 text-[14px] text-black outline-none placeholder:text-gray-500"
                required
              />
            </div>

            <div className="relative col-span-1">
              <User className="pointer-events-none absolute left-5 top-1/2 h-5 w-5 -translate-y-1/2 text-violet" />
              <input
                type="text"
                placeholder="Prénom"
                className="h-16 w-full rounded-full bg-white pl-14 pr-5 text-[14px] text-black outline-none placeholder:text-gray-500"
                required
              />
            </div>

            <div className="relative col-span-1">
              <Mail className="pointer-events-none absolute left-5 top-1/2 h-5 w-5 -translate-y-1/2 text-violet" />
              <input
                type="email"
                placeholder="Email"
                className="h-16 w-full rounded-full bg-white pl-14 pr-5 text-[14px] text-black outline-none placeholder:text-gray-500"
                required
              />
            </div>

            <div className="relative col-span-1">
              <Phone className="pointer-events-none absolute left-5 top-1/2 h-5 w-5 -translate-y-1/2 text-violet" />
              <input
                type="tel"
                placeholder="Téléphone"
                className="h-16 w-full rounded-full bg-white pl-14 pr-5 text-[14px] text-black outline-none placeholder:text-gray-500"
                required
              />
            </div>

            <div className="relative col-span-2">
              <MapPin className="pointer-events-none absolute left-5 top-1/2 h-5 w-5 -translate-y-1/2 text-violet" />
              <input
                type="text"
                placeholder="Adresse de livraison"
                className="h-16 w-full rounded-full bg-white pl-14 pr-5 text-[14px] text-black outline-none placeholder:text-gray-500"
                required
              />
            </div>

            <div className="relative col-span-2">
              <Pencil className="pointer-events-none absolute left-5 top-1/2 h-5 w-5 -translate-y-1/2 text-violet" />

              <select
                defaultValue=""
                className="h-16 w-full appearance-none rounded-full border border-transparent bg-white pl-14 pr-12 text-[14px] text-black outline-none transition focus:border-violet focus:ring-2 focus:ring-violet/20"
                required
              >
                <option value="" disabled>
                  Sujet de votre demande
                </option>
                <option value="Demande d’informations sur nos offres">
                  Demande d’informations sur nos offres
                </option>
                <option value="Demande de devis">
                  Demande de devis
                </option>
                <option value="Support client">
                  Support client
                </option>
              </select>

              <ChevronDown className="pointer-events-none absolute right-5 top-1/2 h-5 w-5 -translate-y-1/2 text-black" />
            </div>

            <div className="relative col-span-2 ">
              <MessageSquare className="pointer-events-none absolute left-5 top-6 h-5 w-5 text-violet" />
              <textarea
                placeholder="Message"
                rows={3}
                className="min-h-[120px] w-full rounded-[32px] bg-white pl-14 pr-5 pt-5 text-[14px] text-black outline-none placeholder:text-gray-500"
              />
            </div>
          </div>

          <label className="mt-6 flex items-start gap-3 text-sm leading-6 text-black md:text-[14px]">
            <input
              type="checkbox"
              defaultChecked
              className="mt-1 h-4 w-4 rounded border-gray-300 accent-[#65A30D]"
              required
            />
            <span>
              J’accepte que mes données soient utilisées pour traiter ma demande
              conformément à la{" "}
              <Link href="/politique-de-confidentialite" className="underline">
                Politique de confidentialité
              </Link>
              .
            </span>
          </label>

          <div className="mt-10 flex justify-center">
            <button
              type="submit"
              className="inline-flex items-center gap-3 rounded-full bg-violet px-10 py-4 text-[18px] font-semibold text-black transition hover:opacity-90"
            >
              Envoyer
              <ArrowRightCircle className="h-5 w-5" />
            </button>
          </div>
        </form>
      </div>
    </section>
  );
}